import type { IconProps } from './types';

export const Image01Icon = (props: IconProps) => {
  const { color = 'currentColor', size = 21, ref, ...other } = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      {...other}
    >
      <path
        d="M2.625 15.75L7.3125 11.0625L12.9375 16.6875L15.75 13.875L21.375 19.5M2.625 21.375V2.625H21.375V21.375H2.625ZM15.75 6.375C16.7856 6.375 17.625 7.21447 17.625 8.25C17.625 9.28553 16.7856 10.125 15.75 10.125C14.7144 10.125 13.875 9.28553 13.875 8.25C13.875 7.21447 14.7144 6.375 15.75 6.375Z"
        stroke={color}
        strokeWidth="1.5"
      />
    </svg>
  );
};
